module.exports = require("npm:async.util.restparam@0.5.2/index.js");